import { render, staticRenderFns } from "./appletNews.vue?vue&type=template&id=1217294a&scoped=true"
import script from "./appletNews.vue?vue&type=script&lang=js"
export * from "./appletNews.vue?vue&type=script&lang=js"
import style0 from "./appletNews.vue?vue&type=style&index=0&id=1217294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217294a",
  null
  
)

export default component.exports